
export default {
	namespaced: true,
	state: {
		msalConfig: {
			auth: {
				clientId: '779d37a9-dda4-43d6-82a8-eacd9933e6e9',
				authority:
					'https://login.microsoftonline.com/c0c8af84-81ad-4d48-ad80-c906993c718b',
				redirectUri: 'https://location-manager.backoffice.americar.com/',
				postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
				clientCapabilities: ['CP1'], // this lets the resource owner know that this client is capable of handling claims challenge.
			},
			cache: {
				cacheLocation: 'localStorage',
			},
		},
		accessToken: ''
	},
	mutations: {
		setAccessToken(state, token) {
			state.accessToken = token;
		}
	}
}
